<template>
  <section class="custom-wrapper">
    <div class="row">
      <div class="col-md-12">
        <p>Use the following to establish General Information Links by Vehicle Make and Year Range.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <matrix-info :source="4" @changed="isHighlight = true" />
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import MatrixInfo from './matrix-info.vue'
export default {
  name: 'AdasInfo',
  components: {
    MatrixInfo
  },
  data() {
    return {
      isHighlight: false
    }
  },
  computed: {
    ...mapState(adasmatrixStore, ['loading', 'adasmatrix'])
  },
  methods: {
    ...mapActions(adasmatrixStore, ['saveAdasMatrix']),
    async save() {
      console.log('Saving')
      // await this.saveAdasMatrix(this.adasmatrix)
      this.isHighlight = false
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
}
</style>
